import type { ReactNode } from 'react'

import { cn } from '@gto/ui/cn'

import type { OverlayTitleSize } from '../typography/overlay-title.styles'
import { CloseButton } from './close-button'
import { Title } from './title'

type HeaderProps = {
  children?: ReactNode
  className?: string
  /** Title size. `default` = h6 (20px); `lg` = h4 (32px) for promo/upgrade takeovers. */
  size?: OverlayTitleSize
  /** When provided, renders a close (X) IconButton. */
  onClose?: () => void
  /** aria-label for the close button. Defaults to "Close". */
  closeLabel?: string
  /** Optional className to customize close button position/style. Merged with default positioning. */
  closeButtonClassName?: string
}

export const Header = ({
  children,
  className,
  size,
  onClose,
  closeLabel = 'Close',
  closeButtonClassName,
}: HeaderProps) => {
  return (
    <div
      className={cn(
        'relative flex items-center justify-between',
        // The close (X) button is absolutely positioned at right-0, so only the
        // right edge needs reserving to keep the title clear of it — pr, not px,
        // so there is no dead left gutter. (FE-707)
        onClose && 'pr-8',
        className,
      )}
    >
      <Title size={size}>{children}</Title>
      {onClose && (
        <CloseButton
          className={cn('top-1/2 -translate-y-1/2', closeButtonClassName)}
          label={closeLabel}
          onClose={onClose}
        />
      )}
    </div>
  )
}
